import axios from "axios";

export const ADMIN = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

ADMIN.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config;
  if (err.response?.status === 401 && !cfg._retried && !cfg.url.startsWith("/auth/")) {
    cfg._retried = true;
    await ADMIN.post("/auth/refresh");
    return ADMIN(cfg);
  }
  throw err;
});

export const formatDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};
